import Cookie from 'react-cookie';
import Modal from '../../shared/modal';
import React from 'react';
import request from 'superagent';
import WatchedSearchItem from './watched-search-item';
import $ from 'jquery';

export default class ManageWatchedSearches extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      searches:[]
    };
  }

  componentDidMount(){
    $(window).on('manageWatchedSearches.open', this.openModal);
    $(window).on('manageWatchedSearches.close', this.closeModal);
  }

  componentWillUnmount(){
    $(window).off('manageWatchedSearches.open', this.openModal);
    $(window).off('manageWatchedSearches.close', this.closeModal);
  }

  openModal = (e) => {
    request
      .post('/api/watches/manage')
      .set('Content-Type', 'application/json')
      .send({
        email: decodeURIComponent(Cookie.load('userEmail'))
      })
      .end(function (error, response) {
        this.setState({searches:response.body});
        this.setState({isOpen:true});
      }.bind(this));
    e.stopPropagation();
  }

  closeModal = () => {
    this.reset();
  }

  reset = () => {
    this.setState({
      isOpen: false,
      searches:[]
    });
  }

  deleteItem = (id) => {
    this.setState({searches: []});
    request
      .post('/api/watches/remove')
      .set('Content-Type', 'application/json')
      .send({
        id: id,
        email: decodeURIComponent(Cookie.load('userEmail'))
      })
      .end((error, response) => {
        if (!error) {
          this.setState({searches: response.body});
        } else {
          alert('There was an error with your request. Please try again later!');
        }
      });
  }

  render() {
    const searchItems = this.state.searches.map((search,index) => {
      return (
        <WatchedSearchItem
          key={index}
          item={search}
          delete={this.deleteItem}
        />
      );
    });

    const body = this.state.searches.length ? (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Frequency</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
          {searchItems}
          </tbody>
        </table>
      </div>
    ) : (
      <div>
        <p>You don't have any watched searches.</p>
      </div>
    );

    let modal;
    if (this.state.isOpen) {
      modal = (
        <Modal isOpen={this.state.isOpen} transitionName="fade">
          <div className="modal-dialog">
            <div className="modal-header">
              <button type="button" className="close" aria-label="Close" onClick={this.closeModal}><span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Manage Watched Searches</h4>
            </div>
            <div>
              <div className="modal-body">
                <p>

                </p>
                <br />
                <div>
                {body}
                </div>
              </div>

              <div className="modal-footer">
                <a href='#' className="primary-button" onClick={this.closeModal}>Close</a>
              </div>
            </div>
          </div>
        </Modal>
      );
    }

    return (
      <span id="modal-manage">
        {modal}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search/watch-this-search/manage-watched-searches.jsx